/* DC 03/11/2026 — FICHE PRODUIT « GALERIE » : comportement (maquette finale validée par Marco, « yes c'est sympa » ;
   code d'origine : scratchpad fiche-sobre/finale/outils/finale.js, porté sur le vrai thème).
   Marquage : snippets/dc-fiche.liquid (#dcf, #dcf-data) et snippets/dc-fiche-rubriques.liquid (#dcf-rub). Styles : dc-fiche.css.

   MOTEUR : la section Horizon « main » (product-information) reste dans la page, cachée. Choisir un format ici coche le même
   format dans SON sélecteur (Horizon met à jour l'URL ?variant=, le formulaire, et le thème suit : encadré de stock de
   sections/dc-product-head.liquid, propriété de ligne « Retrait »…). « Ajouter » règle SA quantité et envoie SON formulaire
   (tiroir du panier, garde du stock, événements cart:update / cart:error) : rien n'est refait à côté.
   VÉRITÉ : stock = mêmes mots et même seuil que le reste du thème (window.dcStock, snippets/dc-glass.liquid) ; quantité
   plafonnée au stock moins ce qui est déjà au panier ; grand format proposé seulement s'il contient assez, est disponible,
   s'expédie et revient vraiment moins cher livré (tarifs lus dans #dcf-port, rendu de snippets/dc-port-tarifs.liquid ; sans
   tarif connu — marché pro, autre pays — aucune promesse de port : moins cher en prix ET pas plus lourd).
   DC 04/11/2026, Marco — FICHE « LE FIL » (décisions du 03/11, maquette finale v2 et SPEC : scratchpad\fiche-fil) : le mur
   monte sous la pilule de l'en-tête (geometrie) ; la pose du produit fusionne les réglages de la maquette (plafond de
   résolution, centrage optique, air autour du sceau DC) ; la phrase clé filtrée et l'aperçu de « Pourquoi le choisir »
   (accroche, apercus) ; les notes de dose déjà dites (règle du 03/11) sur le nouveau balisage ; la frise des 7 étapes (rail,
   panneaux) ; les doublons retirés de « Vous aimerez aussi ». Le choix du format, l'ajout au panier et la barre d'achat
   (téléphone et ordinateur) ne changent pas.
   DC 04/11/2026, Marco — CONTRÔLE 1 de « Le fil » (scratchpad\fiche-fil\controle-1) : quantité envoyée même après un lien
   ?variant= vers un format épuisé (ajouter) ; « Default Title » jamais écrit (barre) ; « Retrait en magasin uniquement » au lieu
   de « Épuisé » quand aucun format n'est vendu dans le marché ; vignettes qui tiennent dans le mur ; carte du mur au-dessus de
   la barre d'achat à l'ordinateur ; mur raccourci pour un produit en paysage ; fondu des bords du rail des étapes ; puce au pH contraire masquée ; ligne d'étiquette d'une dose limitée à certains formats.
   DC 04/11/2026, Marco — CONTRÔLE 2 de « Le fil » (scratchpad\fiche-fil\controle-2) : le moteur Horizon suit TOUJOURS le format
   de la fiche (vente bloquée sur un lien ?variant= vers un bidon vu de France : moteurChoisir, ajouter, démarrage) ; propriété
   « Retrait » alignée sur le format envoyé ; l'encadré de stock prévenu du format de la fiche (dcf:format) ; « Vous aimerez
   aussi » suit la même règle de mise en avant que Le matériel et la frise ; une ligne sous le rail des étapes quand aucune
   n'est ouverte.
   DC 04/11/2026 (avant publication) : moteur Horizon qui ne suit pas le format de la fiche malgré les relances = « Ajouter » et
   la barre grisés avec un message (S.ko), jamais un « Ajouter » actif qui n'envoie rien ; ils reviennent dès que le moteur suit. */
(function () {
  'use strict';
  if (window.__dcFiche) return;
  var root = document.getElementById('dcf');
  if (!root) return;
  window.__dcFiche = 1;

  var doc = document;
  var $ = function (s, r) { return (r || doc).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || doc).querySelectorAll(s)); };
  var lire = function (id) { try { var e = doc.getElementById(id); return e ? JSON.parse(e.textContent) : null; } catch (err) { return null; } };

  var D = lire('dcf-data');
  if (!D || !D.variants || !D.variants.length) return;
  var PH = lire('dc-phmap') || {};
  var V = D.variants;
  var parId = {};
  V.forEach(function (v) { parId[String(v.id)] = v; });
  var NB = ' ';

  // ---------- montants au format de la boutique (modèle lu sur 1 234,56) ----------
  var MF = String(D.exemple || '').match(/^(.*?)1([^\d]?)234([^\d])56(.*)$/);
  function money(c) {
    var n = Math.round(c), ent = String(Math.floor(n / 100)), dec = String(n % 100);
    if (dec.length < 2) dec = '0' + dec;
    if (!MF) return ent + ',' + dec + NB + '€';
    if (MF[2]) ent = ent.replace(/\B(?=(\d{3})+(?!\d))/g, MF[2]);
    return MF[1] + ent + MF[3] + dec + MF[4];
  }

  // ---------- état du stock : vocabulaire unique du thème ----------
  var SEUIL = (window.dcStock && typeof window.dcStock.seuil === 'number') ? window.dcStock.seuil : (D.seuil || 2);
  function etat(v) {
    if (!v) return { st: 'out', mot: 'Épuisé' };
    var rec = { a: v.a, q: v.q };
    if (window.dcStock && window.dcStock.etat) { var e = window.dcStock.etat(rec); if (e) return e; }
    if (v.a === false || (typeof v.q === 'number' && v.q <= 0)) return { st: 'out', mot: 'Épuisé' };
    if (typeof v.q === 'number' && v.q <= SEUIL) return { st: 'low', mot: v.q === 1 ? 'Dernier en stock' : 'Plus que ' + v.q + ' en stock' };
    return { st: 'in', mot: 'En stock' };
  }
  var PAN = { montant: (D.panier && D.panier.montant) || 0, g: (D.panier && D.panier.g) || 0, q: (D.panier && D.panier.q) || {} };
  function dejaAuPanier(v) { return PAN.q[String(v.id)] || 0; }
  function plafond(v) {
    if (typeof v.q === 'number') return Math.max(0, v.q - dejaAuPanier(v));
    return 99;
  }
  function proposable(v) { return D.be || !v.r; }

  // ---------- tarifs de port (source unique : snippets/dc-port-tarifs.liquid, rendu dans #dcf-port) ----------
  var PORT = (function () {
    var t = doc.getElementById('dcf-port');
    if (!t || !t.content) return null;
    var bas = t.content.querySelector('[data-dc-port="bas"]');
    if (!bas) return null;
    var m = bas.textContent.match(/(\d+)[.,](\d{2})/);
    var seuil = parseInt(bas.getAttribute('data-seuil'), 10);
    if (!m || !seuil) return null;
    // au-delà de 20 kg, dc-port-tarifs ne donne aucun tarif (envoi en plusieurs colis) : on ne promet rien
    return { relais: parseInt(m[1], 10) * 100 + parseInt(m[2], 10), seuil: seuil, gMax: 20000 };
  })();
  function port(montant, g) {
    if (!PORT || g > PORT.gMax) return null;
    return montant >= PORT.seuil ? 0 : PORT.relais;
  }

  // ---------- état de la page ----------
  var S = { sel: String(D.sel), q: 1, photo: 0, attente: 0, ko: false };
  // DC 04/11/2026 : photo de départ = celle que la fiche a servie (photo du format choisi), lue sur la vignette déjà soulignée
  (function () { var b = root.querySelector('.dcf-dots.fx-vign button[aria-pressed="true"]'); if (b) S.photo = parseInt(b.getAttribute('data-photo'), 10) || 0; })();
  if (!parId[S.sel] || !proposable(parId[S.sel])) {
    var prem = V.filter(function (v) { return proposable(v) && etat(v).st !== 'out'; })[0] || V.filter(proposable)[0] || V[0];
    S.sel = String(prem.id);
  }

  // ---------- le moteur Horizon (caché) ----------
  function moteur() { return $('main > .shopify-section[id$="__main"]') || null; }
  function moteurId() {
    var m = moteur(); if (!m) return null;
    var i = m.querySelector('product-form-component input[name="id"], form[action*="/cart/add"] input[name="id"]');
    return i ? String(i.value) : null;
  }
  /* DC 04/11/2026, Marco (contrôle 2 de « Le fil », VENTE BLOQUÉE : 1 arrivée sur 8 en France par un lien ?variant= vers un
     bidon, flux Google Shopping ou Meta) : la fiche montrait « Ajouter · 14,99 € » (1 L) mais le moteur Horizon caché était
     resté sur le 20 L ; « Ajouter » et la barre échouaient à chaque essai (« Le format n’a pas pu être choisi »), sans
     recharger la page. Cause : le clic sur le bouton radio d'Horizon, fait avant qu'Horizon n'ait défini son sélecteur
     (variant-picker.js est un module chargé après ce script), coche le bouton radio mais personne n'écoute ; ensuite le bouton
     radio est « déjà coché » et n'était plus jamais recliqué. Désormais : bouton radio déjà coché alors que le formulaire
     d'Horizon porte un autre format, et que l'adresse ne montre pas ce format (Horizon ne l'a donc jamais traité) — ou
     « forcer » (2e essai de ajouter()) : son événement « change » est relancé, la mise à jour native d'Horizon suit (même
     geste que snippets/dc-variants.liquid pour le format d'arrivée déjà coché). Un bouton radio désactivé n'est jamais touché. */
  function urlVariant() { try { return new URLSearchParams(location.search).get('variant'); } catch (err) { return null; } }
  function moteurChoisir(v, forcer) {
    var m = moteur(); if (!m) return false;
    var vp = m.querySelector('variant-picker'); if (!vp) return false;
    var fs = vp.querySelectorAll('fieldset'), id = String(v.id);
    var relancer = function () { return moteurId() !== id && (forcer || urlVariant() !== id); };
    if (fs.length) {
      var clique = false, dernier = null;
      v.o.forEach(function (val, i) {
        var f = fs[i]; if (!f) return;
        var r = Array.prototype.filter.call(f.querySelectorAll('input[type="radio"]'), function (x) { return x.value === val; })[0];
        if (!r || r.disabled) return;
        dernier = r;
        if (!r.checked) { r.click(); clique = true; }
      });
      if (!clique && dernier && relancer()) dernier.dispatchEvent(new Event('change', { bubbles: true }));
    } else {
      var ss = vp.querySelectorAll('select'), change = false, derS = null;
      v.o.forEach(function (val, i) {
        var s = ss[i]; if (!s) return;
        derS = s;
        if (s.value !== val) { s.value = val; s.dispatchEvent(new Event('change', { bubbles: true })); change = true; }
      });
      if (!change && derS && relancer()) derS.dispatchEvent(new Event('change', { bubbles: true }));
    }
    return true;
  }
  function attendre(test, ms) {
    return new Promise(function (ok) {
      if (test()) return ok(true);
      var t0 = Date.now();
      var iv = setInterval(function () { if (test()) { clearInterval(iv); ok(true); } else if (Date.now() - t0 > ms) { clearInterval(iv); ok(false); } }, 60);
    });
  }
  /* DC 04/11/2026 (avant publication, vente bloquée vue de France) : S.ko = le moteur n'a pas suivi le format de la fiche malgré
     les relances (2 essais de ajouter(), contrôles du démarrage). Tant qu'il ne le porte pas, « Ajouter » et la barre sont grisés
     et le message est affiché (rendre) : jamais un « Ajouter » actif qui n'envoie rien. Une relance forcée part toutes les 3 s
     (5 au plus) ; dès que le moteur porte le format de la fiche, tout revient. */
  var MSG_KO = 'Ce format n’a pas pu être préparé. Rechargez la page pour l’ajouter au panier.';
  var koIv = 0;
  function bloque() { return !!S.ko && !!moteur() && moteurId() !== S.sel; }
  function poserKo() {
    S.ko = true;
    rendre();
    if (koIv) return;
    var n = 0;
    koIv = setInterval(function () {
      if (!bloque()) { clearInterval(koIv); koIv = 0; if (S.ko) { S.ko = false; rendre(); } return; }
      n++;
      if (n % 5 === 0 && n <= 25 && !S.attente && parId[S.sel]) moteurChoisir(parId[S.sel], true);
    }, 600);
  }

  // ---------- éléments ----------
  var E = {
    prix: $('#dcf-prix'), was: $('#dcf-was'), pl: $('#dcf-pl'), act: $('#dcf-act'), q: $('#dcf-q'), add: $('#dcf-add'),
    msg: $('#dcf-msg'), grand: $('#dcf-grand'), stage: $('#dcf-stage'), pose: $('#dcf-pose'), ombre: $('#dcf-ombre'),
    img: $('#dcf-pack')
  };
  var qBtns = $$('.dcf-qty button', root);

  function libelle(v) {
    if (v.aff) return v.aff.replace(/ /g, NB);
    return v.t;
  }
  // DC 03/11/2026, Marco (« il faut mettre le prix au litre pour les formats d'1 litre ou plus sinon ça fait bizarre ») :
  // prix au litre (ou au kilo) seulement à partir de 1 L / 1 kg ; en dessous, la contenance seule (« 500 ml »)
  function plTexte(v) {
    if (v.v && v.u && v.v >= 1) return money(v.p / v.v) + '/' + v.u + ' · ' + libelle(v);
    if (v.v && v.u) return libelle(v);
    // DC 04/11/2026 (contrôle 2, Kwazar Sprayer : « 500ml » collé, « 500 ml » dans l'encadré) : la graphie de l'encadré
    // (champ « aff » d'un format d'outil, snippets/dc-fiche-graphie.liquid), sinon le nom du format tel quel
    return D.uneOption ? libelle(v) : '';
  }

  // ---------- tuiles à plusieurs options : état de chaque valeur selon le reste du choix ----------
  function trouver(opts) {
    for (var i = 0; i < V.length; i++) {
      var o = V[i].o, ok = true;
      for (var k = 0; k < opts.length; k++) { if (o[k] !== opts[k]) { ok = false; break; } }
      if (ok) return V[i];
    }
    return null;
  }
  function meilleurAvec(i, val) {
    var avec = V.filter(function (v) { return v.o[i] === val && proposable(v); });
    return avec.filter(function (v) { return etat(v).st !== 'out'; })[0] || avec[0] || null;
  }

  // ---------- la ligne du grand format ----------
  function proposition(v, n) {
    if (!D.uneOption || n < 2 || !v.v || v.r) return null;
    var besoin = v.v * n, prod = v.p * n, best = null;
    V.forEach(function (g) {
      if (String(g.id) === String(v.id) || g.r || !g.v || g.u !== v.u || g.v <= v.v || g.v < besoin - 1e-9) return;
      if (etat(g).st === 'out' || plafond(g) < 1) return;
      if (PORT) {
        var pc = port(PAN.montant + prod, PAN.g + v.g * n), pa = port(PAN.montant + g.p, PAN.g + g.g);
        if (pc === null || pa === null) return;
        var cur = prod + pc, alt = g.p + pa;
        if (alt < cur - 0.5 && (!best || g.v < best.g.v)) best = { g: g, cur: cur, alt: alt, pa: pa, pc: pc };
      } else if (g.p < prod - 0.5 && g.g <= v.g * n && (!best || g.v < best.g.v)) {
        best = { g: g, cur: prod, alt: g.p, sansPort: true };
      }
    });
    if (best) { best.prod = prod; best.plus = best.g.v > besoin + 1e-9; }
    return best;
  }

  // ---------- rendu ----------
  // DC 04/11/2026 (contrôle 1) : produit SANS option (format unique « Default Title » de Shopify : 164 fiches sur 555, machines,
  // outils, kits) ; son nom technique n'est jamais écrit (la barre disait « 1 × Default Title · 579,99 € »)
  var UNIQUE = !!D.unique || (V.length === 1 && V[0].t === 'Default Title');
  function rendre() {
    var v = parId[S.sel], e = etat(v), out = e.st === 'out', cap = plafond(v);
    /* DC 04/11/2026 (contrôle 1, France) : AUCUN format proposable dans le marché (bidon en retrait magasin seul, vu de France :
       Shopify le sert « non disponible ») : le bouton ne dit pas « Épuisé » (le produit n'est pas épuisé, il ne s'expédie pas),
       il dit « Retrait en magasin uniquement », grisé, comme l'encadré (sections/dc-product-head.liquid) ; pas de barre */
    var hors = !proposable(v);
    if (hors) out = true;
    var ko = bloque();
    if (S.q > Math.max(1, cap)) S.q = Math.max(1, cap);
    var tot = v.p * S.q;
    if (E.prix) E.prix.textContent = money(v.p);
    if (E.was) { if (v.c && v.c > v.p) { E.was.textContent = money(v.c); E.was.hidden = false; } else { E.was.hidden = true; } }
    if (E.pl) E.pl.textContent = plTexte(v);
    if (E.q) E.q.textContent = S.q;
    if (qBtns[0]) qBtns[0].disabled = out || S.q <= 1;
    if (qBtns[1]) qBtns[1].disabled = out || S.q >= cap;
    if (E.act) E.act.classList.toggle('is-out', out);
    if (E.add && !E.add.classList.contains('is-ok')) {
      if (hors) { E.add.disabled = true; E.add.textContent = 'Retrait en magasin uniquement'; }
      else if (out) { E.add.disabled = true; E.add.textContent = 'Épuisé'; }
      else if (cap < 1) { E.add.disabled = true; E.add.textContent = 'Déjà au panier'; }
      else { E.add.disabled = ko; E.add.innerHTML = 'Ajouter<span class="dcf-sep" aria-hidden="true">·</span><span class="dcf-vh"> pour </span>' + money(tot); }
    }
    // DC 04/11/2026 (avant publication) : moteur bloqué sur un autre format (S.ko) : message tant que le format est commandable
    if (ko && !out && cap >= 1) message(MSG_KO);
    else if (E.msg && E.msg.textContent === MSG_KO) message('');
    // tuiles
    if (D.uneOption) {
      $$('#dcf-tiles .dcf-tile').forEach(function (b) { b.setAttribute('aria-pressed', b.getAttribute('data-vid') === S.sel ? 'true' : 'false'); });
    } else {
      $$('.dcf-tiles--val', root).forEach(function (grp) {
        var i = parseInt(grp.getAttribute('data-opt'), 10);
        $$('.dcf-tile', grp).forEach(function (b) {
          var val = b.getAttribute('data-val');
          var o = v.o.slice(); o[i] = val;
          var cand = trouver(o);
          if (cand && !proposable(cand)) cand = null;
          // la valeur reste choisissable si UNE variante qui la porte est en stock (le reste du choix suivra) ;
          // barrée seulement quand aucune ne l'est
          var ref = (cand && etat(cand).st !== 'out') ? cand : meilleurAvec(i, val);
          var st = ref ? etat(ref).st : 'out';
          b.classList.remove('is-in', 'is-low', 'is-out', 'is-none');
          b.classList.add(!ref ? 'is-none' : 'is-' + st);
          b.setAttribute('aria-pressed', v.o[i] === val ? 'true' : 'false');
          if (!ref || st === 'out') b.setAttribute('aria-disabled', 'true'); else b.removeAttribute('aria-disabled');
          var vh = b.querySelector('.dcf-vh'); if (vh) vh.textContent = ref ? ', ' + etat(ref).mot.toLowerCase() : ', indisponible';
        });
      });
    }
    // grand format
    if (E.grand) {
      var pr = !out && S.q > 1 ? proposition(v, S.q) : null;
      if (pr) {
        var memePort = pr.sansPort || pr.pa === pr.pc;
        E.grand.innerHTML = '<span>' + S.q + NB + '×' + NB + libelle(v) + ' = ' + money(pr.prod) + '. Le ' + libelle(pr.g) + ' contient ' + (pr.plus ? 'plus' : 'autant') +
          ' pour <b>' + money(pr.g.p) + '</b>' + (memePort ? '' : ' + ' + money(pr.pa) + ' de port') + ', soit ' + money(pr.cur - pr.alt) + ' de moins' + (memePort ? '' : ' livré') +
          '. <button type="button" data-go="' + pr.g.id + '">Prendre le ' + libelle(pr.g) + '</button></span>';
        E.grand.hidden = false;
      } else { E.grand.hidden = true; E.grand.textContent = ''; }
    }
    // pH (même table que la pastille du thème : dc-phmap ; une variante sans pH n'en montre aucun) ; DC 04/11/2026 (« Le fil ») :
    // la case pH de la bande « Le produit » (snippets/dc-fiche-bande.liquid) ; seule, « Sur quoi » prend toute la largeur
    var row = doc.getElementById('dcf-ph-row');
    if (row) {
      var rec = PH[S.sel] || null;
      row.hidden = !rec;
      if (rec) {
        var val = parseFloat(String(rec.v).replace(',', '.'));
        var pv = doc.getElementById('dcf-ph-v'); if (pv) pv.textContent = rec.v;
        var pn = doc.getElementById('dcf-ph-n'); if (pn) pn.textContent = String(rec.n || '').toLowerCase();
        var pb = doc.getElementById('dcf-ph-b'); if (pb && !isNaN(val)) pb.style.left = (Math.max(0, Math.min(14, val)) / 14 * 100).toFixed(1) + '%';
      }
      var duo = doc.getElementById('dcf-duo');
      if (duo) {
        var vus = $$('.fx-duo__c', duo).filter(function (c) { return !c.hidden; }).length;
        duo.hidden = !vus; duo.classList.toggle('fx-duo--1', vus < 2);
      }
      // DC 04/11/2026 (contrôle 1, un nettoyant jantes : « pH 13 » dans une puce, « pH 13,1 » sur la règle) : une puce de « Pourquoi le
      // choisir » qui donne un AUTRE pH que celui affiché (métachamp) est cachée ; même pH, ou aucun pH affiché : elle reste
      var phv = rec ? parseFloat(String(rec.v).replace(',', '.')) : NaN;
      $$('#dcf-bande .fx-ligne[data-k="pourquoi"] .fx-ligne__p li').forEach(function (li) {
        var m = li.textContent.match(/\bpH\s*(\d+(?:[.,]\d+)?)/);
        li.hidden = !!(m && !isNaN(phv) && Math.abs(parseFloat(m[1].replace(',', '.')) - phv) > 0.001);
      });
    }
    // DC 04/11/2026 (contrôle 1, Fraber Lega) : « Suivez l'étiquette pour le dosage. » d'une fiche dont la dose vérifiée ne vaut que
    // pour certains formats (doses-verifiees.json, champ « variantes » ; snippets/dc-fiche-rubriques.liquid, data-pur) : cachée
    // seulement quand le format choisi est un de ceux que la dose vérifiée dit prêts à l'emploi (« pur »)
    $$('#dcf-fil .fx-etiq[data-pur]').forEach(function (p) {
      var pur = p.getAttribute('data-pur').toLowerCase().replace(/\s+/g, '').split('|');
      p.hidden = v.o.some(function (x) { return pur.indexOf(String(x).toLowerCase().replace(/\s+/g, '')) >= 0; });
    });
    // outils sous condition de format (ex. un doseur pour le 10 L seulement) ; DC 04/11/2026 : cartes de « Le matériel », une
    // carte seule devient horizontale
    var avec = doc.getElementById('dcf-avec');
    if (avec) {
      var cartes = $$('.fx-carte', avec);
      cartes.forEach(function (a) {
        var c = a.getAttribute('data-cond'); if (!c) return;
        c = c.toLowerCase().replace(/\s+/g, '');
        a.hidden = !v.o.some(function (x) { return String(x).toLowerCase().replace(/\s+/g, '') === c; });
      });
      var vis = cartes.filter(function (a) { return !a.hidden; });
      var col = avec.closest('.fx-col') || avec;
      col.hidden = !vis.length;
      var gr = $('.fx-cartes', avec); if (gr) gr.classList.toggle('fx-cartes--1', vis.length === 1);
      vis.forEach(function (a) { a.classList.toggle('fx-carte--h', vis.length === 1); });
    }
    // barre du téléphone. REPRISE 1 (03/11) : format épuisé = pas de barre du tout (surDefilement) ; le bouton ne reste
    // jamais grisé « Ajouter » à côté d'un bouton principal « Épuisé » ; déjà tout au panier : « Au panier », grisé
    if (BAR) {
      BAR.__out = out;
      $('.dcf-bar__p', BAR).textContent = (UNIQUE ? 'Quantité' + NB + S.q : S.q + NB + '×' + NB + (D.uneOption ? libelle(v) : v.t)) + ' · ' + money(tot);
      var bb = $('button', BAR);
      bb.disabled = out || cap < 1 || ko;
      bb.textContent = (!out && cap < 1) ? 'Au panier' : 'Ajouter';
      surDefilement();
    }
    prixLignes();
    /* DC 04/11/2026 (contrôle 2, lien ?variant= vers un format épuisé en Belgique, ou vers un bidon en France) : l'encadré de
       stock suit le format de LA FICHE (sections/dc-product-head.liquid, committedId lit window.__dcf), pas l'adresse ni le
       moteur, qu'Horizon a pu basculer sur un autre format : il est prévenu quand ce format change */
    if (S.annonce !== S.sel) {
      S.annonce = S.sel;
      try { doc.dispatchEvent(new CustomEvent('dcf:format', { detail: { id: S.sel } })); } catch (err) {}
    }
  }

  // POLISH 03/11 : la ligne du prix ne tient pas (promo au téléphone) -> 2 lignes composées (.is-2, assets/dc-fiche.css) :
  // prix + ancien prix, puis prix au litre + « Taxes incluses », au lieu de « Taxes incluses » seul sur une 2e ligne
  function prixLignes() {
    var p = $('.dcf-price', root); if (!p) return;
    var b = p.querySelector('b'), t = p.querySelector('.dcf-tax');
    p.classList.remove('is-2');
    // alignés sur la ligne de base, « Taxes incluses » commence plus bas que le prix sur la même ligne : on compare son haut
    // au BAS du prix (passé à la ligne = sous le prix)
    if (b && t && t.getBoundingClientRect().top >= b.getBoundingClientRect().bottom - 1) p.classList.add('is-2');
  }

  // ---------- choisir un format ----------
  function choisir(id, q) {
    var v = parId[String(id)];
    if (!v || !proposable(v)) return;
    S.sel = String(v.id);
    S.q = q || 1;
    message('');
    moteurChoisir(v);
    rendre();
    if (v.m) { var k = (D.photos || []).map(function (p) { return p.id; }).indexOf(v.m); if (k >= 0 && k !== S.photo) montrerPhoto(k); }
  }

  // ---------- ajouter au panier, par le formulaire du moteur ----------
  function message(t, ok) {
    if (!E.msg) return;
    E.msg.textContent = t || '';
    E.msg.hidden = !t;
    E.msg.classList.toggle('is-ok', !!ok);
  }
  function occupe(on) { if (E.add) { E.add.classList.toggle('is-busy', on); E.add.setAttribute('aria-busy', on ? 'true' : 'false'); } }
  function ajouter() {
    var v = parId[S.sel];
    if (!v || etat(v).st === 'out' || plafond(v) < 1 || S.attente || bloque()) return;
    message('');
    var m = moteur();
    if (!m) return secours(v);
    occupe(true);
    S.attente = Date.now();
    /* DC 04/11/2026 (contrôle 2, vente bloquée : voir moteurChoisir) : si le moteur n'a pas suivi au bout de 4 s, 2e essai qui
       relance la mise à jour d'Horizon même sur un bouton radio déjà coché (clic perdu, requête de section échouée), 4 s de
       plus, puis seulement le message. Format changé : 180 ms d'attente avant l'envoi, le temps que les règles du thème qui
       suivent le formulaire (propriété de ligne « Retrait », snippets/dc-retrait.liquid, rafale à 0 et 120 ms) le relisent. */
    var vid = String(v.id), suit = function () { return moteurId() === vid; }, change = !suit();
    var pret = !change ? Promise.resolve(true) : (moteurChoisir(v), attendre(suit, 4000)).then(function (ok) {
      if (ok) return true;
      moteurChoisir(v, true);
      return attendre(suit, 4000);
    });
    // DC 04/11/2026 (avant publication) : échec après les deux essais = « Ajouter » et la barre grisés avec le message (poserKo)
    pret.then(function (ok) {
      if (!ok) { fini(); poserKo(); return; }
      if (change) setTimeout(envoyer, 180); else envoyer();
    });
    function envoyer() {
      if (!suit()) { fini(); poserKo(); return; }
      S.attente = Date.now();
      var qc = m.querySelector('product-form-component quantity-selector-component');
      var qi = m.querySelector('product-form-component input[name="quantity"]');
      /* DC 04/11/2026, Marco (contrôle 1 de « Le fil », VRAIES COMMANDES) : arrivée par un lien ?variant= vers un format épuisé
         (Belgique) ou non vendu dans le marché (France, bidon), cas réel des flux Google Shopping et Meta : Horizon sert le champ
         quantité caché en « disabled » et ne le réactive pas quand la fiche change de format. FormData ignore un champ désactivé :
         /cart/add.js partait SANS quantity et Shopify ajoutait 1 (« 11 × 1 L » affiché, 1 au panier). Le champ est réactivé
         ici, juste avant l'envoi (le format est déjà celui de la fiche : disponible). Défaut identique sur le thème en ligne. */
      if (qi && qi.disabled) qi.disabled = false;
      if (qc && typeof qc.setValue === 'function') qc.setValue(String(S.q)); else if (qi) qi.value = String(S.q);
      if (qi) { qi.dispatchEvent(new Event('input', { bubbles: true })); qi.dispatchEvent(new Event('change', { bubbles: true })); }
      var btn = m.querySelector('product-form-component add-to-cart-component button[type="submit"], product-form-component button[type="submit"]');
      var form = m.querySelector('product-form-component form[action*="/cart/add"]');
      // filet : si le formulaire ne porte toujours pas la quantité choisie (champ absent ou hors du formulaire), elle y est posée
      // dans un champ caché à nous (jamais deux champs « quantity » actifs à la fois)
      if (form) {
        $$('input[data-dcf-q]', form).forEach(function (x) { x.parentNode.removeChild(x); });
        var fq = null;
        try { fq = new FormData(form).get('quantity'); } catch (err) {}
        if (fq === null) {
          var aNous = doc.createElement('input'); aNous.type = 'hidden'; aNous.name = 'quantity'; aNous.value = String(S.q); aNous.setAttribute('data-dcf-q', '');
          form.appendChild(aNous);
        } else if (String(fq) !== String(S.q) && qi && !qi.disabled) qi.value = String(S.q);
        /* DC 04/11/2026 (contrôle 2) : la propriété de ligne « Retrait » est TOUJOURS celle du format envoyé (même règle que
           snippets/dc-retrait.liquid : format en retrait magasin = propriété ; les deux lisent snippets/dc-est-retrait.liquid).
           Arrivée sur un 20 L (propriété posée) puis 1 L choisi : un envoi plus rapide que la rafale de dc-retrait aurait
           marqué un 1 L « Retrait : Magasin uniquement ». */
        var pr = form.querySelector('input[data-dc-retrait]');
        /* DC 04/11/2026 (contrôle avant publication) : arrivée par ?variant= sur un 20 L et appui sur « Ajouter » dans les
           premières dizaines de millisecondes (35 à 70 ms mesurées), avant que snippets/dc-retrait.liquid ait créé le champ :
           le 20 L partait sans la propriété. Le champ manquant est créé ICI, à l'identique de champ() de dc-retrait.liquid
           (même nom, même valeur, même attribut) : dc-retrait le retrouve ensuite et ne le double jamais. */
        if (!pr && v.r) {
          pr = doc.createElement('input'); pr.type = 'hidden'; pr.name = 'properties[Retrait]';
          pr.value = 'Magasin uniquement (non expédiable)'; pr.setAttribute('data-dc-retrait', '1');
          form.appendChild(pr);
        }
        if (pr) pr.disabled = !v.r;
      }
      if (btn && !btn.disabled) btn.click();
      else if (form && form.requestSubmit) form.requestSubmit();
      else { fini(); return secours(v); }
      setTimeout(function () { if (S.attente) fini(); }, 9000);
    }
  }
  function fini() { S.attente = 0; occupe(false); }
  // sans moteur (gabarit modifié) : ajout direct, puis la page panier
  function secours(v) {
    occupe(true);
    fetch((window.Shopify && window.Shopify.routes && window.Shopify.routes.root || '/') + 'cart/add.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: v.id, quantity: S.q }] })
    }).then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
      .then(function (x) { occupe(false); if (x.ok) location.href = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root || '/') + 'cart'; else message((x.j && (x.j.description || x.j.message)) || 'Ajout impossible.'); })
      .catch(function () { occupe(false); message('Ajout impossible. Vérifiez votre connexion.'); });
  }
  function relirePanier() {
    return fetch((window.Shopify && window.Shopify.routes && window.Shopify.routes.root || '/') + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) {
        var q = {};
        (c.items || []).forEach(function (it) { if (String(it.product_id) === String(D.id)) q[String(it.variant_id)] = (q[String(it.variant_id)] || 0) + it.quantity; });
        var montant = c.items_subtotal_price || 0;
        (c.cart_level_discount_applications || []).forEach(function (d) { montant -= (d.total_allocated_amount || 0); });
        PAN = { montant: montant, g: c.total_weight || 0, q: q };
        rendre();
      }).catch(function () {});
  }
  doc.addEventListener('cart:update', function (e) {
    var d = (e && e.detail && e.detail.data) || {};
    if (S.attente && Date.now() - S.attente < 12000) {
      fini();
      if (d.didError) { message('Ajout impossible pour le moment. Réessayez.'); }
      else if (E.add) {
        E.add.classList.add('is-ok');
        E.add.textContent = 'Ajouté au panier';
        setTimeout(function () { E.add.classList.remove('is-ok'); rendre(); }, 1800);
      }
    }
    relirePanier();
  });
  doc.addEventListener('cart:error', function (e) {
    if (!S.attente) return;
    fini();
    var d = (e && e.detail && e.detail.data) || {};
    var t = (typeof d.description === 'string' && d.description) || (typeof d.message === 'string' && d.message) || 'Ajout impossible pour le moment.';
    message(t);
    relirePanier();
  });

  // ---------- le mur : pose du produit devant le monogramme (réglages de la maquette validée) ----------
  var PHOTOS = D.photos || [];
  var BOITES = {};
  function boite(src) {
    // contour du produit (pixels non blancs, ou non transparents), dans le carré où la photo est posée en « contain »
    if (BOITES[src]) return BOITES[src];
    BOITES[src] = new Promise(function (ok) {
      var im = new Image();
      im.crossOrigin = 'anonymous';
      im.onload = function () {
        try {
          var N = 160, c = doc.createElement('canvas'); c.width = N; c.height = N;
          var x = c.getContext('2d', { willReadFrequently: true });
          var w = im.naturalWidth, h = im.naturalHeight, k = N / Math.max(w, h), dw = w * k, dh = h * k, ox = (N - dw) / 2, oy = (N - dh) / 2;
          x.drawImage(im, ox, oy, dw, dh);
          var d = x.getImageData(0, 0, N, N).data;
          var coin = function (px, py) { return d[(Math.floor(py) * N + Math.floor(px)) * 4 + 3]; };
          var transp = coin(ox + 1, oy + 1) < 250 || coin(ox + dw - 2, oy + 1) < 250 || coin(ox + 1, oy + dh - 2) < 250 || coin(ox + dw - 2, oy + dh - 2) < 250;
          var x0 = N, y0 = N, x1 = -1, y1 = -1;
          for (var py = 0; py < N; py++) {
            for (var px = 0; px < N; px++) {
              var i = (py * N + px) * 4, a = d[i + 3];
              var plein = transp ? a > 24 : (a > 200 && Math.max(255 - d[i], 255 - d[i + 1], 255 - d[i + 2]) > 14);
              if (plein) { if (px < x0) x0 = px; if (px > x1) x1 = px; if (py < y0) y0 = py; if (py > y1) y1 = py; }
            }
          }
          if (x1 < 0) return ok({ b: [0, 0, 1, 1], transp: transp });
          ok({ b: [x0 / N, y0 / N, (x1 + 1) / N, (y1 + 1) / N], transp: transp });
        } catch (err) { ok({ b: [0, 0, 1, 1], transp: false }); }
      };
      im.onerror = function () { ok({ b: [0, 0, 1, 1], transp: false }); };
      im.src = src;
    });
    return BOITES[src];
  }
  var BB = { b: [0, 0, 1, 1], transp: false };
  function largeurPhoto(src, w) { return String(src).replace(/([?&])width=\d+/, '$1width=' + w); }
  /* DC 04/11/2026, Marco (« Le fil », « plus de démarcation sous l'en-tête ») : LE MUR MONTE SOUS LA PILULE de l'en-tête,
     comme sur l'accueil où l'en-tête flotte sur la photo : aucune bande claire ni filet entre la barre noire d'annonce et le
     mur, au téléphone comme à l'ordinateur (où le mur reste une carte arrondie). Tout est MESURÉ, jamais codé en dur (la
     hauteur de l'annonce change selon la largeur et les copies) ; la page est d'abord remise telle quelle (remontée annulée)
     pour la mesure, puis :
     - téléphone, Fold : le mur part sous l'annonce (--fx-remonte = haut de la fiche − bas de l'annonce) et grandit d'autant,
       l'achat ne bouge pas ; le produit se pose sous la pilule (zone = bas de la pilule + 12 px) ;
     - ordinateur : la carte du mur part du haut de la pilule (collée à ce niveau au défilement), grandit d'autant, son coin
       haut gauche prend le rayon de la pilule ; la colonne d'achat reçoit le même écart en marge haute (l'achat ne bouge pas) ;
       le produit se pose sous la pilule (hauteur de la pilule + 18 px).
       REMPLACÉ le 04/11/2026 (retours de Marco sur l'aperçu, ~10:50, « le carré ne doit pas être collé à l'en-tête ») : à
       l'ordinateur, plus de remontée ; la carte est posée sous la pilule avec un vrai espace, en carré (branche « pc » plus bas).
       Le téléphone et le Fold gardent la règle ci-dessus.
     Sans script, rien ne remonte (assets/dc-fiche.css lit var(--fx-remonte, 0px) sous #dcf.fx-monte). */
  var GEO = null;
  /* DC 04/11/2026 (contrôle 1, 1366 × 768) : à l'ordinateur, la carte du mur finit AU-DESSUS de la barre d'achat flottante
     (publiée le 03/11, inchangée : bas 16 px + sa hauteur + 12 px d'air). Avant, elle finissait à 24 px du bas de l'écran et la
     barre, quand elle est là (dès l'arrivée sur une fiche à beaucoup de formats, ou au défilement), cachait les 70 px du bas du
     mur : les vignettes et le sceau DC. Hauteur minimale ramenée de 560 à 480 px (écrans de 768 px de haut). */
  function reserveBarre() { return ((BAR && BAR.offsetHeight) || 78) + 16 + 12; }
  /* DC 04/11/2026 (retours de Marco, ~10:50) : à l'ordinateur, l'air entre le bas de la pilule de l'en-tête et le haut de la carte
     du mur, et la hauteur de la carte : sa largeur (un carré), sans dépasser la place donnée (dispo), ni descendre sous 420 px */
  var ECART_PC = 28;
  function carre(dispo) {
    var W = (E.stage && E.stage.clientWidth) || 620;
    return Math.round(Math.min(W, Math.max(420, dispo)));
  }
  function geometrie(force) {
    var topEl = $('.dcf-top', root), hg = doc.getElementById('header-group');
    var pil = hg && hg.querySelector('.header__row--top');
    // seulement au démarrage et quand la LARGEUR change (et la hauteur à l'ordinateur, qui règle la hauteur du mur) : au
    // téléphone, la barre d'adresse qui s'efface au défilement change la hauteur de la fenêtre, et rien ne doit bouger alors ;
    // un « resize » envoyé par la page (carrousel de « Vous aimerez aussi ») ne remesure rien non plus ; « force » : la mesure
    // du produit vient de décider un mur en paysage (hauteurPaysage)
    if (!force && GEO && GEO.w === window.innerWidth && (GEO.w < 1000 || GEO.hh === window.innerHeight)) return;
    root.classList.remove('fx-monte');
    ['--fx-remonte', '--fx-buy', '--fx-rpil', '--fx-hbase', '--fx-haut'].forEach(function (k) { root.style.removeProperty(k); });
    GEO = null;
    if (!topEl || !pil || !E.stage) {
      // en-tête introuvable (autre disposition) : rien ne remonte ; à l'ordinateur, la carte du mur reste un CARRÉ (DC 04/11/2026)
      // qui tient dans l'écran
      if (topEl && window.innerWidth >= 1000) {
        var hdr = $('#header-group') || $('.header-section') || $('header');
        var hb = hdr ? Math.max(0, Math.round(hdr.getBoundingClientRect().bottom)) : 80;
        root.style.setProperty('--dcf-top', Math.min(140, Math.max(72, hb + 16)) + 'px');
        var deb = topEl.getBoundingClientRect().top + window.scrollY + parseFloat(getComputedStyle(topEl).paddingTop || 0);
        root.style.setProperty('--dcf-h', carre(window.innerHeight - deb - reserveBarre()) + 'px');
      }
      return;
    }
    var sy = window.scrollY || 0, pc = window.innerWidth >= 1000;
    var an = hg.querySelector('.announcement-bar');
    var anSec = an ? (an.closest('.shopify-section') || an) : null;
    var pr = pil.getBoundingClientRect(), pm = parseFloat(getComputedStyle(pil).marginTop) || 0;
    // bas de l'annonce et haut de la pilule dans la page, tels qu'en haut de page : en haut de page, l'annonce finit là où
    // commence la marge haute de la pilule ; plus bas, l'en-tête est collant (ailleurs à l'écran) : on lit alors des HAUTEURS
    // (l'en-tête commence en haut de la page), jamais des positions
    var anBas = sy < 2 ? pr.top - pm : (anSec ? anSec.offsetHeight : 0);
    var pilHaut = sy < 2 ? pr.top : anBas + pm;
    var debut = topEl.getBoundingClientRect().top + sy;
    if (pc) {
      /* DC 04/11/2026, retours de Marco sur l'aperçu (~10:50) : à l'ordinateur, le mur n'est plus collé à l'en-tête ni glissé
         sous sa pilule : c'est une CARTE POSÉE SOUS L'EN-TÊTE, à ECART_PC px sous le bas de la pilule (même bord gauche
         qu'elle, aucune bande claire : le blanc de la page), et au défilement elle reste à la même distance sous la pilule
         collante. Le haut de la colonne d'achat (sur-titre) est aligné sur le haut de la carte (assets/dc-fiche.css). La carte
         est un CARRÉ (rapport 1:1, avant ≈ 620 × 820 px) tant qu'il tient dans l'écran au-dessus de la barre d'achat
         flottante ; sur un écran bas, elle garde sa largeur et perd un peu de hauteur (jamais sous 420 px). */
      var hs = pil.closest('.header-section') || pil.closest('.shopify-section') || hg;
      var hsTop = parseFloat(getComputedStyle(hs).top); if (isNaN(hsTop)) hsTop = 0;
      var pilBas = pilHaut + pr.height;
      var collant = Math.round(hsTop + pr.bottom - hs.getBoundingClientRect().top);
      var hautCarte = pilBas + ECART_PC;
      root.style.setProperty('--fx-haut', Math.max(0, Math.round(hautCarte - debut)) + 'px');
      root.style.setProperty('--dcf-top', Math.max(0, collant + ECART_PC) + 'px');
      GEO = { haut: 0, w: window.innerWidth, hh: window.innerHeight };
      root.style.setProperty('--dcf-h', hauteurPaysage(carre(window.innerHeight - hautCarte - reserveBarre())) + 'px');
      return;
    } else {
      var rem = Math.max(0, Math.round(debut - anBas));
      root.style.setProperty('--fx-remonte', rem + 'px');
      GEO = { haut: Math.round(pilHaut - anBas + pr.height + 12), w: window.innerWidth, hh: window.innerHeight };
      root.classList.add('fx-monte');
      var h0 = E.stage.clientHeight, h1 = hauteurPaysage(h0, rem);
      if (h1 < h0) root.style.setProperty('--fx-hbase', (h1 - rem) + 'px');
    }
    root.classList.add('fx-monte');
  }
  /* DC 04/11/2026 (contrôle 1, critique art 5 « ramener le mur vers le carré pour les photos en paysage ») : MUR EN PAYSAGE. Un
     produit large (polisseuse, kit, objet plat) est plafonné en largeur et laissait le mur vide au-dessus et en dessous (Rupes
     LHR15 MK5 : 24 % de la hauteur du mur au téléphone, 20 % à l'ordinateur). Le contour mesuré de la photo d'ARRIVÉE
     (boite()) décide une fois : quand le produit, à sa largeur maximale, occuperait moins de la moitié de la zone de pose (55 %
     à l'ordinateur), le mur est raccourci jusqu'à cette proportion, sans descendre sous 72 % de sa largeur au téléphone (plus
     la remontée sous la pilule) ni 75 % à l'ordinateur ; un produit en hauteur ne change rien. Ordinateur : la carte du mur est
     seule dans sa colonne, rien ne bouge autour. Téléphone : seulement si la mesure arrive avant que le client ait fait
     défiler la page, dans les 3 premières secondes (sinon le mur garde sa hauteur : rien ne saute sous le doigt). Changer de
     photo ensuite ne change plus la hauteur (le produit s'ajuste dans le mur). */
  var T0 = Date.now();
  var PAYSAGE = { a: 0, tel: false, fait: false };
  /* DC 04/11/2026, retours de Marco sur l'aperçu (~10:50 : « le flacon remplit presque tout le carré ») : le produit est posé
     PLUS PETIT pour qu'il respire, surtout à l'ordinateur : hauteur 84 → 68 % de la zone de pose, largeur 80 → 64 % ; Fold
     86 → 80 % et 74 → 68 % ; téléphone, toujours généreux, 90 → 84 % et 86 → 80 %. Même règle pour toutes les photos : rien ne
     saute au changement de photo (le mur garde sa taille, seul le contour de chaque photo change sa pose, comme avant). */
  function reglages(H) {
    var vw = window.innerWidth, pc = vw >= 1000, fold = vw >= 600, vign = PHOTOS.length > 1;
    return {
      pc: pc, fold: fold,
      bas: vign ? (pc ? 96 : fold ? 82 : 70) : (pc ? 44 : fold ? 38 : 30),
      haut: (GEO && GEO.haut) || Math.round(H * 0.07),
      // DC 04/11/2026, Marco (« un trop gros produit c'est moche » ; référence : un flacon seul occupe environ les deux tiers
      // de la hauteur de l'image, avec de l'air autour) : même présence pour tous les produits. Trois plafonds : hauteur
      // (kH, part de la zone), largeur (kW, part du mur) et « présence » (kA : part de la surface zone × largeur que le
      // contour du produit peut occuper) ; un flacon fin est arrêté par la hauteur, un groupe carré par la présence, un
      // produit couché par la largeur. Avant : 0,68 / 0,8 / 0,84 en hauteur, sans plafond de présence.
      // Puis (Marco, même jour) : « il faudrait quand même les agrandir un peu sur PC » : l'ordinateur passe à 0,80 / 0,70 / 0,34
      // (environ 60 % de la hauteur du carré pour un flacon ou un duo), le téléphone reste aux deux tiers de la hauteur au plus.
      kH: pc ? 0.8 : fold ? 0.68 : 0.64,
      kW: pc ? 0.7 : fold ? 0.66 : 0.7,
      kA: pc ? 0.34 : fold ? 0.3 : 0.3
    };
  }
  function hauteurPaysage(H, rem) {
    if (!PAYSAGE.a || !E.stage) return H;
    var R = reglages(H), W = E.stage.clientWidth;
    if (!R.pc && !PAYSAGE.tel) return H;
    var part = R.pc ? 0.55 : 0.5, zone = H - R.bas - R.haut, pH = W * R.kW / PAYSAGE.a;
    if (zone <= 0 || pH >= zone * R.kH || pH >= zone * part) return H;
    var min = R.pc ? W * 0.75 : (rem || 0) + W * 0.72;
    var h = Math.round(Math.max(min, pH / part + R.haut + R.bas));
    return h < H - 24 ? h : H;
  }
  /* LA POSE DU PRODUIT (DC 04/11/2026, « Le fil », SPEC § 4.2 ; fusion des réglages de la maquette dans la pose existante,
     une seule mesure du contour : boite()) :
     - zone = du bas de la pilule au-dessus des vignettes (ou du bord) ; le produit grandit jusqu'à 90 % de la hauteur de la
       zone et 86 % de la largeur au téléphone (86 / 74 au Fold, 84 / 80 à l'ordinateur) ;
     - PLAFOND DE RÉSOLUTION (critique art 7) : jamais plus grand que ce que la photo d'origine permet (grand côté de la photo,
       servie à 1 400 px de large au plus, divisé par la densité de l'écran bornée entre 1,25 et 1,5) ;
     - centrage optique : le vide du haut vaut 1,3 fois le vide du bas ;
     - le petit sceau DC garde son air (critique art 6) : si le contour du produit entre dans son coin (1,6 fois sa largeur), le
       produit est remonté, et réduit s'il le faut ;
     - l'ombre de contact suit la largeur du produit. Une photo d'épuisé n'est JAMAIS grisée. */
  function poser() {
    if (!E.stage || !E.pose) return;
    vignettes();
    var W = E.stage.clientWidth, H = E.stage.clientHeight;
    var R = reglages(H), pc = R.pc, fold = R.fold;
    var cs = getComputedStyle(E.stage);
    var g = parseFloat(cs.getPropertyValue('--fx-sceau-g')) || (pc ? 28 : fold ? 32 : 20);
    var sw = parseFloat(cs.getPropertyValue('--fx-sceau-w')) || 40, sb = parseFloat(cs.getPropertyValue('--fx-sceau-b')) || 16;
    var bas = R.bas, haut = R.haut;
    var bb = BB.b, bw = Math.max(0.05, bb[2] - bb[0]), bh = Math.max(0.05, bb[3] - bb[1]);
    var zone = Math.max(60, H - bas - haut);
    var kH = R.kH, kW = R.kW;
    var s = Math.min(zone * kH / bh, W * kW / bw, Math.sqrt(R.kA * zone * W / (bw * bh)));
    var ph = PHOTOS[S.photo];
    if (ph && ph.w && ph.h) {
      var eff = Math.max(ph.w, ph.h) * Math.min(1, 1400 / ph.w);
      var q = Math.min(1.5, Math.max(1.25, window.devicePixelRatio || 1));
      if (s > eff / q) s = eff / q;
    }
    var pH = s * bh, pW = s * bw;
    var libre = Math.max(0, zone - pH), sol = H - bas - libre / 2.3;
    var left = W / 2 - s * (bb[0] + bb[2]) / 2;
    var exD = g + sw * 1.6, exH = H - sb - sw / 2 - sw * 0.6;
    if (left + s * bb[0] < exD && sol > exH) {
      sol = exH - 2;
      if (sol - pH < haut) { s = Math.max(10, (sol - haut) / bh); pH = s * bh; pW = s * bw; left = W / 2 - s * (bb[0] + bb[2]) / 2; }
    }
    var ps = E.pose.style;
    ps.width = s + 'px'; ps.height = s + 'px'; ps.left = left + 'px'; ps.top = (sol - s * bb[3]) + 'px';
    E.pose.classList.toggle('is-detoure', !!BB.transp);
    if (E.ombre) {
      var os = E.ombre.style;
      os.left = (W / 2) + 'px'; os.top = (sol - 1) + 'px'; os.width = Math.max(64, pW * 1.02) + 'px'; os.height = Math.max(16, Math.min(30, pW * 0.085)) + 'px';
    }
    E.stage.classList.add('fx-pose');
  }
  function photoCourante() { return PHOTOS[S.photo] || null; }
  function analyser() {
    var p = photoCourante();
    if (!p) { poser(); return; }
    boite(p.petit || p.src).then(function (r) {
      // la 1re mesure décide du mur en paysage (hauteurPaysage), une seule fois
      if (!PAYSAGE.fait) {
        PAYSAGE.fait = true;
        var bw = r.b[2] - r.b[0], bh = r.b[3] - r.b[1];
        if (bw > 0.05 && bh > 0.05 && bw / bh > 1.15) {
          PAYSAGE.a = bw / bh;
          PAYSAGE.tel = (window.scrollY || 0) < 8 && Date.now() - T0 < 3000;
          geometrie(true);
          surDefilement();
        }
      }
      if (photoCourante() === p) { BB = r; poser(); }
    });
  }
  /* DC 04/11/2026 (contrôle 1, Aromatic 89 Spray : 8 vignettes, la 1re hors écran au Fold plié, le sceau recouvert à 344, 412
     et 1024 px) : LES VIGNETTES TIENNENT DANS LE MUR. Place = largeur du mur − retrait droit de la rangée − (marge du sceau +
     sceau + 12 px). Tout tient : largeur prévue (48, 56, 64 px) ; sinon chaque vignette se resserre, jusqu'à 30 px (cible de
     30 × 50 px et plus) ; au-delà, les dernières sont masquées (le glissement du doigt sur le mur passe par toutes les photos). */
  /* DC 04/11/2026 (contrôle avant publication, Aromatic 89 : 8 vignettes de 34 px à 344 et 41 px à 412, bord à bord, collées
     au sceau, « ne fait pas fini ») : une vignette ne descend plus sous 48 px (taille téléphone de la SPEC § 4.3, au-dessus de
     la cible tactile de 44 px), même au Fold ou à l'ordinateur où elle mesure d'habitude 56 ou 64 px. Quand elles ne tiennent pas
     toutes, la dernière place devient « +N » (N = photos qui n'ont pas de vignette, elle comprise), en petit chiffre posé sur
     le mur, sans tuile : un appui montre la première de ces photos, puis la suivante à chaque appui ; elle est soulignée tant
     qu'une de ces photos est montrée. Le glissement du doigt sur le mur passe toujours par toutes les photos. */
  var VK = 0;
  function vignettes() {
    var dots = $('.dcf-dots.fx-vign', root); if (!dots || !E.stage) return;
    var bs = $$('button', dots); if (!bs.length) return;
    dots.style.removeProperty('--fx-vw'); dots.style.removeProperty('--fx-vp');
    VK = 0;
    bs.forEach(function (b) {
      b.hidden = false;
      if (b.classList.contains('fx-vign__plus')) {
        b.classList.remove('fx-vign__plus'); b.removeAttribute('data-plus');
        if (b.hasAttribute('data-l')) b.setAttribute('aria-label', b.getAttribute('data-l'));
      }
    });
    var cs = getComputedStyle(E.stage), W = E.stage.clientWidth;
    var g = parseFloat(cs.getPropertyValue('--fx-sceau-g')) || 20, sw = parseFloat(cs.getPropertyValue('--fx-sceau-w')) || 40;
    var droite = parseFloat(getComputedStyle(dots).right) || 8;
    var nominal = bs[0].offsetWidth || 48, place = W - droite - (g + sw + 12);
    if (bs.length * nominal <= place) { pressees(); return; }
    var w = Math.floor(place / bs.length);
    var mini = Math.min(nominal, 48);
    if (w < mini) {
      var k = Math.max(2, Math.floor(place / mini));
      w = Math.min(nominal, Math.floor(place / k));
      bs.forEach(function (b, i) { if (i >= k) b.hidden = true; });
      var pl = bs[k - 1], n = bs.length - (k - 1);
      if (!pl.hasAttribute('data-l')) pl.setAttribute('data-l', pl.getAttribute('aria-label') || '');
      pl.classList.add('fx-vign__plus');
      pl.setAttribute('data-plus', '+' + n);
      pl.setAttribute('aria-label', n + ' autres photos');
      VK = k;
    }
    dots.style.setProperty('--fx-vw', w + 'px');
    dots.style.setProperty('--fx-vp', Math.max(2, Math.round(w * 0.1)) + 'px');
    pressees();
  }
  // vignette soulignée : celle de la photo montrée, ou « +N » pour une photo sans vignette
  function pressees() {
    $$('.dcf-dots button', root).forEach(function (b, i) {
      var on = VK && i === VK - 1 ? S.photo >= VK - 1 : i === S.photo;
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
  }
  function montrerPhoto(k) {
    if (!PHOTOS[k] || !E.img) return;
    S.photo = k;
    var w = window.innerWidth >= 1000 ? 1400 : 900;
    E.img.removeAttribute('srcset');
    E.img.removeAttribute('sizes');
    E.img.src = largeurPhoto(PHOTOS[k].src, w);
    pressees();
    analyser();
  }

  // ---------- interactions ----------
  root.addEventListener('click', function (e) {
    var t = e.target.closest && e.target.closest('button');
    if (!t || !root.contains(t)) return;
    if (t.classList.contains('dcf-tile')) {
      if (t.getAttribute('aria-disabled') === 'true') return;
      if (t.hasAttribute('data-vid')) { choisir(t.getAttribute('data-vid')); return; }
      var grp = t.closest('.dcf-tiles--val'); if (!grp) return;
      var i = parseInt(grp.getAttribute('data-opt'), 10), val = t.getAttribute('data-val');
      var o = parId[S.sel].o.slice(); o[i] = val;
      var cand = trouver(o);
      if (!cand || !proposable(cand) || etat(cand).st === 'out') cand = meilleurAvec(i, val);
      if (cand) choisir(cand.id);
    } else if (t.hasAttribute('data-q')) {
      var v = parId[S.sel];
      S.q = Math.max(1, Math.min(plafond(v), S.q + parseInt(t.getAttribute('data-q'), 10)));
      rendre();
    } else if (t.hasAttribute('data-go')) {
      var g = parId[t.getAttribute('data-go')], cur = parId[S.sel];
      if (g && cur && cur.v && g.v) choisir(g.id, Math.max(1, Math.ceil(cur.v * S.q / g.v - 1e-9)));
    } else if (t.id === 'dcf-add') {
      ajouter();
    } else if (t.hasAttribute('data-photo')) {
      // DC 04/11/2026 : « +N » montre la première photo sans vignette, puis la suivante à chaque appui (voir vignettes)
      if (VK && t.classList.contains('fx-vign__plus')) {
        var nb = $$('.dcf-dots.fx-vign button', root).length;
        montrerPhoto(S.photo >= VK - 1 && S.photo < nb - 1 ? S.photo + 1 : VK - 1);
      } else montrerPhoto(parseInt(t.getAttribute('data-photo'), 10));
    }
  });
  // REPRISE 1 : « Réassort ou alternative : appelez-nous » (format épuisé, encadré) descend en douceur à l'encart des
  // numéros, qui reçoit le focus (lecteurs d'écran, clavier) ; sans script, l'ancre #dcf-tel-q suffit
  root.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('a[href="#dcf-tel-q"]');
    var cible = a && doc.getElementById('dcf-tel-q');
    if (!cible) return;
    e.preventDefault();
    var doux = !window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    cible.scrollIntoView({ behavior: doux ? 'smooth' : 'auto', block: 'start' });
    var bloc = cible.closest('.dcf-tel') || cible;
    if (!bloc.hasAttribute('tabindex')) bloc.setAttribute('tabindex', '-1');
    try { bloc.focus({ preventScroll: true }); } catch (err) {}
  });
  if (E.stage && PHOTOS.length > 1) {
    var x0 = null;
    E.stage.addEventListener('pointerdown', function (e) { x0 = e.clientX; });
    E.stage.addEventListener('pointerup', function (e) {
      if (x0 === null) return;
      var dx = e.clientX - x0; x0 = null;
      if (Math.abs(dx) > 40) montrerPhoto((S.photo + (dx < 0 ? 1 : PHOTOS.length - 1)) % PHOTOS.length);
    });
  }

  // ---------- barre d'achat du téléphone (après le bouton, fond blanc plein) ----------
  // REPRISE 1 (03/11, 344 px) : 1re ligne = le NOM COURT, le même que le titre de la fiche (D.nom : sans la marque, ni
  // « Fraber » devant « Polish Plus Aroma ») ; la marque le suit seulement si elle tient ENTIÈRE sur la ligne (jamais
  // « · Koch Che… ») ; 2e ligne : quantité, format et total. Le nom seul ne se coupe qu'en dernier recours.
  var BAR = null;
  (function () {
    BAR = doc.createElement('div');
    BAR.id = 'dcf-bar';
    BAR.setAttribute('role', 'region');
    BAR.setAttribute('aria-label', 'Ajout au panier');
    // DC 03/11/2026, Marco : la barre porte la photo du produit (la 1re photo, en petit)
    BAR.innerHTML = '<span class="dcf-bar__img" aria-hidden="true"><img alt="" width="44" height="44" decoding="async"></span><div class="dcf-bar__t"><span class="dcf-bar__n"><span class="dcf-bar__nom"></span><span class="dcf-bar__m"></span></span><span class="dcf-bar__p"></span></div><button type="button">Ajouter</button>';
    $('.dcf-bar__nom', BAR).textContent = D.nom || '';
    var ph = (D.photos && D.photos[0]) || null, bi = $('.dcf-bar__img', BAR);
    if (ph && ph.petit) $('img', bi).src = ph.petit; else bi.hidden = true;
    $('.dcf-bar__m', BAR).textContent = D.marque ? ' · ' + D.marque : '';
    $('button', BAR).addEventListener('click', ajouter);
    doc.body.appendChild(BAR);
  })();
  function barreMarque() {
    if (!BAR) return;
    var n = $('.dcf-bar__n', BAR), m = $('.dcf-bar__m', BAR);
    if (!n || !m || !m.textContent) return;
    m.hidden = false;
    if (n.scrollWidth > n.clientWidth + 1) m.hidden = true;
  }
  var pied = $('footer') || $('.shopify-section-group-footer-group') || $('[id*="footer"]');
  function surDefilement() {
    if (!BAR || !E.act) return;
    var r = E.act.getBoundingClientRect(), fr = pied ? pied.getBoundingClientRect() : null;
    // DC 03/11/2026, Marco (« il faut la barre sur desktop aussi ») : à l'ordinateur, le pied de page est fixe sous la page
    // (sections/dc-footer.liquid) et toujours « dans l'écran » ; c'est son intercalaire .dcf-spacer qui dit quand il arrive
    var sp = window.innerWidth >= 1000 ? doc.querySelector('.dcf-spacer') : null;
    if (sp && sp.offsetHeight) fr = sp.getBoundingClientRect();
    // DC 03/11/2026, Marco : la barre est là dès l'arrivée sur la fiche, disparaît tant que le bouton « Ajouter » est à
    // l'écran et réapparaît dès qu'il n'y est plus (au-dessus comme en dessous) ; toujours cachée sur le pied de page
    // un bouton qui n'apparaît que sous la hauteur de la barre, tout en bas de l'écran, ne compte pas comme « vu »
    var vu = r.bottom > 0 && r.top < window.innerHeight - (BAR.offsetHeight || 64);
    var on = !BAR.__out && !vu && !(fr && fr.top < window.innerHeight);
    if (on && !BAR.classList.contains('on')) barreMarque();
    BAR.classList.toggle('on', on);
  }
  window.addEventListener('scroll', surDefilement, { passive: true });
  var rz = 0;
  window.addEventListener('resize', function () { clearTimeout(rz); rz = setTimeout(function () { geometrie(); poser(); barreMarque(); surDefilement(); prixLignes(); }, 80); });

  /* DEBUT-NOTES — REPRISE 1 (03/11, directeur artistique) : « Comment l'utiliser » disait trois fois la même consigne (sous
     la dose, dans les étapes, puis dans la précaution ; Green Star « 5 minutes d'action au maximum » puis « Jamais plus de
     5 minutes d'action. »). Une note de la dose (ul.dcf-pied--l li) n'est plus montrée quand une étape ou une précaution
     la dit déjà. Comparaison sur les MOTS PORTEURS (minuscules, sans accents, sans ponctuation, sans petits mots, pluriel
     en -s ramené au singulier ; « 1:3 » reste un seul mot) : la note est coupée en propositions aux virgules et
     points-virgules (jamais à la virgule d'un nombre, « pH 13,4 ») ; chacune doit retrouver au moins les 3/4 de ses mots
     porteurs (et tous s'ils sont 2 ou 3), chiffres compris tels quels, dans UNE même étape ou précaution ; le vouvoiement
     des étapes compte comme l'infinitif des notes (« Portez » = « Porter ») ; une note d'UN seul mot porteur (« Pas sur
     les motos ») n'est masquée que si un même membre de phrase d'une étape ou précaution porte ce mot avec la même
     négation (« Ne pas utiliser sur les motos. ») ; sinon elle reste. Aucun mot n'est changé ni ajouté :
     la consigne reste dite une fois, dans l'étape ou la précaution. Liste des notes masquées sur toutes les fiches à dose :
     scratchpad avant-publication\polish-reprise-1 (relue avant l'envoi). */
  var PETITS = {};
  ('a à au aux avec ce ces cet cette d de des du dans en et est il ils elle la le les l leur lui ne n ni on ou où par pas '
    + 'pour que qu qui sa se ses si son sur un une y vos votre nos notre tout tous toute toutes puis bien très tres sans '
    + 'plus moins').split(' ').forEach(function (m) { PETITS[m] = 1; });
  function plat(t) {
    return String(t || '').toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '')
      .replace(/(\d)\s*[:\/,.]\s*(\d)/g, '$1x$2').replace(/[’'`]/g, ' ').replace(/[^a-z0-9]+/g, ' ');
  }
  function porteurs(t) {
    var out = [];
    plat(t).split(' ').forEach(function (w) {
      if (!w || PETITS[w] || (w.length < 2 && !/\d/.test(w))) return;
      if (w.length > 4 && /ez$/.test(w)) w = w.slice(0, -2) + 'er';
      if (w.length > 3 && /[sx]$/.test(w) && !/\d/.test(w)) w = w.slice(0, -1);
      if (out.indexOf(w) < 0) out.push(w);
    });
    return out;
  }
  function negatif(t) { return /(^| )(ne|n|pas|jamais|ni)( |$)/.test(plat(t)); }
  // découpe aux virgules et points-virgules, jamais à la virgule d'un nombre (« pH 13,4 », « 1,5 L »)
  function membres(t, sep) {
    return String(t).replace(/(\d)\s*,\s*(\d)/g, '$1\u0001$2').split(sep)
      .map(function (x) { return x.replace(/\u0001/g, ',').trim(); }).filter(Boolean);
  }
  // un chiffre (« 5 », « 1:3 », « 30 ») doit TOUJOURS se retrouver tel quel : « 5 minutes » n'est jamais tenue pour dite
  // par « 10 minutes »
  function couverte(prop, cibles) {
    var w = porteurs(prop);
    if (!w.length) return true;
    var chiffres = w.filter(function (x) { return /\d/.test(x); });
    var besoin = w.length <= 3 ? w.length : Math.ceil(w.length * 0.75);
    return cibles.some(function (c) {
      if (!chiffres.every(function (x) { return c.indexOf(x) >= 0; })) return false;
      return w.filter(function (x) { return c.indexOf(x) >= 0; }).length >= besoin;
    });
  }
  function notesDejaDites(rub) {
    // DC 04/11/2026 (« Le fil ») : mêmes règles ; les cibles sont les étapes (.fx-pas li, .fx-pas-seul), les consignes rangées
    // sous les cartes de dose (.fx-dose__g) et les précautions ; les notes sont les .fx-note de la légende sous les cartes
    var els = $$('.fx-pas li, .fx-pas-seul, .fx-dose__g, .fx-precs li > span', rub).filter(function (e) { return !e.closest('[hidden]'); });
    var cibles = els.map(function (e) { return porteurs(e.textContent); });
    // membres de phrase des étapes et précautions (pour les notes d'un seul mot) : mots porteurs + négation
    var bouts = [];
    els.forEach(function (e) { membres(e.textContent, /[,;.:]/).forEach(function (m) { bouts.push({ w: porteurs(m), n: negatif(m) }); }); });
    var masquees = [];
    if (!cibles.length) return masquees;
    $$('.fx-legende', rub).forEach(function (lg) {
      var notes = $$('.fx-note', lg), une = false;
      notes.forEach(function (li) {
        var t = li.textContent.replace(/\s+/g, ' ').trim();
        var pw = porteurs(t), dite = false;
        if (!pw.length) return;
        if (pw.length === 1) {
          var ng = negatif(t);
          dite = !/\d/.test(pw[0]) && bouts.some(function (b) { return b.w.indexOf(pw[0]) >= 0 && b.n === ng; });
        } else {
          dite = membres(t, /[,;]/).every(function (p) { return couverte(p, cibles); });
        }
        if (dite) { li.hidden = true; une = true; masquees.push(t); }
      });
      if (!une) return;
      // légende recomposée : notes visibles séparées par « · », puis la source, qui passe EN ENTIER à la ligne (le « · »
      // reste en fin de ligne, critique art 14)
      var vis = notes.filter(function (li) { return !li.hidden; }), src = $('.fx-src', lg);
      lg.textContent = '';
      vis.forEach(function (li, i) { if (i) lg.appendChild(doc.createTextNode(' · ')); lg.appendChild(li); });
      if (src) { if (vis.length) lg.appendChild(doc.createTextNode(' · ')); lg.appendChild(src); }
      if (!vis.length && !src) lg.hidden = true;
    });
    return masquees;
  }
  /* doseFinitions (03/11) est retiré : la règle des segments « a · b » (un segment déjà dit par un autre n'est pas répété) est
     appliquée une fois pour toutes par le générateur des doses (scratchpad\fiche-fil\outils\gen_fil.py) ; les cartes de dose
     n'ont plus de lignes à toucher. */
  /* FIN-NOTES */

  // ---------- rubriques (DC 04/11/2026, « Le fil ») ----------
  /* RÈGLE CHIFFRE (phrase clé, repli, aperçus ; critique vérité 2 de la maquette) : une durée, un pourcentage, une dose, une
     mesure ou un rapport non vérifiés, y compris les durées écrites en lettres (« un an », « deux ans environ », « un mois »).
     Contrôlée sur les 14 accroches de l'audit : 14 écartées (scratchpad\fiche-fil\maquette\outils\test-regles.js). */
  var NOMBRES = '(?:un|une|deux|trois|quatre|cinq|six|sept|huit|neuf|dix|onze|douze|quinze|vingt|trente|cent)';
  var DUREES = '(?:jours?|semaines?|mois|ans?|années?|heures?|minutes?)';
  var CHIFFRE = new RegExp('\\d\\s*(ml|cl|l\\b|litres?|%|mois|ans?\\b|années?|semaines?|jours?|min\\b|minutes?|h\\b|heures?|°|tr\\/min|w\\b|kg|g\\b|mm\\b|cm\\b|m\\b|v\\b|bars?\\b)|\\d+\\s*:\\s*\\d+|\\b' + NOMBRES + '\\s+' + DUREES + '\\b', 'i');
  var txt = function (e) { return e ? e.textContent.replace(/\s+/g, ' ').trim() : ''; };
  var simple = function (t) { return String(t || '').toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace(/[^a-z0-9]+/g, ' ').trim(); };

  /* LA PHRASE CLÉ (SPEC § 6.1) : celle du bloc dc-accroche de la fiche (une seule cascade dans le thème), avec trois filtres :
     1. accroche SUSPENDUE (data-suspendue, snippets/dc-fiche-etapes.liquid : elle contredit la description corrigée) : jamais
        affichée, jamais remplacée, jusqu'à la correction à la source ;
     2. accroche à CHIFFRE non vérifié : écartée ; REPLI sur la 1re phrase du 1er paragraphe de plus de 30 caractères de la
        description, seulement si elle passe la même règle, ne recommence pas par la marque ou le nom du produit (après « le,
        la, les, l' ») et ne dépasse pas 120 caractères ; sinon RIEN (la bande commence à « Sur quoi ») ;
     3. au-delà de 125 caractères : un corps un peu plus petit (.fx-acc--long). */
  function accroche() {
    var lead = doc.getElementById('dcf-lead');
    if (!lead || lead.hasAttribute('data-suspendue')) return '';
    var src = $('main .dc-accroche');
    var acc = src ? txt(src) : '';
    if (acc && CHIFFRE.test(acc)) {
      acc = '';
      var desc = $('#dcf-bande .dcf-desc');
      var p1 = desc ? $$('p', desc).map(txt).filter(function (t) { return t.length > 30; })[0] : '';
      var m1 = p1 ? p1.match(/^(.+?[.!?])(?=\s+[A-ZÀ-Ý«]|\s*$)/) : null;
      if (m1) {
        var ph1 = m1[1], tete = simple(ph1).replace(/^(le|la|les|l)\s+/, ''), mq = simple(D.marque), nm = simple(D.nom);
        var redit = (mq && tete.indexOf(mq) === 0) || (nm && tete.indexOf(nm) === 0);
        if (!CHIFFRE.test(ph1) && ph1.length <= 120 && !redit) acc = ph1;
      }
    }
    if (!acc) return '';
    lead.textContent = acc;
    lead.classList.toggle('fx-acc--long', acc.length > 125);
    lead.hidden = false;
    var bd = doc.getElementById('dcf-bande');
    var nue = bd && bd.classList.contains('fx-bande--nue');
    if (bd) bd.classList.remove('fx-bande--nue');
    /* DC 04/11/2026 (retours de Marco, ~10:50) : à l'ordinateur, la phrase vérifiée est déjà SOUS LE NOM (#dcf-but,
       snippets/dc-fiche.liquid) : la phrase clé de la bande ne la répète pas (cachée à partir de 1000 px, montrée en dessous,
       où la phrase du haut n'est pas affichée) ; une bande qui n'avait qu'elle redevient « nue » */
    var but = doc.getElementById('dcf-but');
    var mq = but && window.matchMedia ? window.matchMedia('(min-width: 1000px)') : null;
    if (mq) {
      var suivre = function () {
        lead.hidden = mq.matches;
        if (bd && nue) bd.classList.toggle('fx-bande--nue', mq.matches);
      };
      suivre();
      if (mq.addEventListener) mq.addEventListener('change', suivre); else if (mq.addListener) mq.addListener(suivre);
    }
    return acc;
  }
  /* L'APERÇU de « Pourquoi le choisir » fermé (SPEC § 6.3) : la 1re puce qui passe la règle CHIFFRE et ne redit pas la phrase
     clé (au moins 2 mots de 5 lettres et plus en commun, et 40 % des mots de la puce) ; sinon la ligne garde son seul libellé. */
  function apercus(acc) {
    var mots = function (t) { return simple(t).split(' ').filter(function (w) { return w.length >= 5; }); };
    var ma = mots(acc);
    var redit = function (t) { var w = mots(t); if (!w.length || !ma.length) return false; var c = w.filter(function (x) { return ma.indexOf(x) >= 0; }).length; return c >= 2 && c / w.length >= 0.4; };
    $$('#dcf-bande .fx-ligne[data-k="pourquoi"]').forEach(function (d) {
      var a = $('.fx-ligne__a', d); if (!a) return;
      var ap = $$('.fx-ligne__p li', d).filter(function (li) { return !li.hidden; }).map(txt).filter(function (t) { return t && !CHIFFRE.test(t) && !redit(t); })[0];
      if (ap) { a.textContent = ap; a.hidden = false; }
    });
  }

  /* LES 7 ÉTAPES (SPEC § 11.2-11.3) : au téléphone et au Fold, un RAIL qui défile (assets/dc-fiche.css) ; à l'ordinateur, 7
     colonnes. L'étape du produit est ouverte à l'arrivée et amenée à l'écran en réglant SEULEMENT le défilement horizontal du
     rail (jamais celui de la page) ; sans étape connue, rien d'ouvert. Un appui ouvre une étape (une seule à la fois), un appui
     sur l'étape ouverte la referme, « Ensuite » ouvre la suivante. Rien ne saute : les panneaux sont empilés dans la même case,
     la zone prend la hauteur du panneau ouvert, l'élément touché reste sous le doigt. Sans script : tous les panneaux visibles
     l'un sous l'autre. */
  function frise() {
    var m = doc.getElementById('fx-methode'), fil = doc.getElementById('dcf-fil');
    if (!m || !fil) return;
    var fr = $('.fx-frise', m), zone = $('.fx-zone', m), pile = $('.fx-zone__pile', m);
    if (!fr || !zone || !pile) return;
    var reduit = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var N = parseInt(fil.getAttribute('data-etape'), 10) || 0;
    m.classList.add('fx-js');
    function railVers(n, doux) {
      if (window.innerWidth >= 1000 || !n) return;
      var b = $('.fx-n[data-n="' + n + '"]', fr); if (!b) return;
      var x = Math.max(0, Math.min(fr.scrollWidth - fr.clientWidth, b.offsetLeft + b.offsetWidth / 2 - fr.clientWidth / 2));
      if (doux && !reduit && fr.scrollTo) fr.scrollTo({ left: x, behavior: 'smooth' }); else fr.scrollLeft = x;
    }
    function hauteur() {
      var b = $('.fx-n[aria-expanded="true"]', fr), po = b ? doc.getElementById('fx-p' + b.getAttribute('data-n')) : null;
      zone.style.height = po ? (po.offsetHeight + (parseFloat(getComputedStyle(pile).paddingTop) || 0)) + 'px' : '0px';
    }
    function ouvrir(n, depuis, doux) {
      var y0 = depuis ? depuis.getBoundingClientRect().top : null;
      $$('.fx-n', fr).forEach(function (b) { b.setAttribute('aria-expanded', String(+b.getAttribute('data-n') === n)); });
      $$('.fx-pan', pile).forEach(function (p) { var on = p.id === 'fx-p' + n; p.classList.toggle('is-ouvert', on); if (on) p.removeAttribute('inert'); else p.setAttribute('inert', ''); });
      // DC 04/11/2026 (contrôle 2, Green Star, Kwazar : rail nu, rien d'ouvert ni d'indiqué) : aucune étape ouverte = la ligne
      // « Choisissez une étape… » sous le rail (snippets/dc-fiche-rubriques.liquid, .fx-zone__vide)
      m.classList.toggle('fx-rien', !n);
      hauteur();
      railVers(n, doux);
      if (depuis && y0 !== null) { var dy = depuis.getBoundingClientRect().top - y0; if (Math.abs(dy) > 1) window.scrollBy(0, dy); }
    }
    // DC 04/11/2026 (contrôle 1 : « es », « Décontaminatio », un rond coupé en deux aux bords du rail) : le fondu des bords
    // s'élargit (assets/dc-fiche.css), et seulement du côté où le rail a encore des étapes à montrer (classes fx-bg, fx-bd)
    function bords() {
      var max = fr.scrollWidth - fr.clientWidth;
      fr.classList.toggle('fx-bg', max > 1 && fr.scrollLeft > 1);
      fr.classList.toggle('fx-bd', max > 1 && fr.scrollLeft < max - 1);
    }
    fr.addEventListener('scroll', bords, { passive: true });
    m.addEventListener('click', function (e) {
      var b = e.target.closest && e.target.closest('.fx-n, .fx-suite'); if (!b || !m.contains(b)) return;
      var n = +b.getAttribute('data-n'), deja = b.classList.contains('fx-n') && b.getAttribute('aria-expanded') === 'true';
      ouvrir(deja ? 0 : n, b.classList.contains('fx-n') ? b : $('.fx-n[data-n="' + n + '"]', fr), true);
    });
    ouvrir(N, null, false);
    bords();
    // la hauteur suit le panneau ouvert (photos chargées après coup, police, largeur)
    if ('ResizeObserver' in window) { var ro = new ResizeObserver(function () { hauteur(); }); $$('.fx-pan', pile).forEach(function (p) { ro.observe(p); }); }
    // au redimensionnement : la hauteur de la zone ; le rail n'est recentré que si la LARGEUR change (au téléphone, la barre
    // d'adresse qui s'efface au défilement ne ramène pas le rail que le client vient de faire glisser)
    var t = 0, larg = window.innerWidth;
    window.addEventListener('resize', function () {
      clearTimeout(t);
      t = setTimeout(function () {
        hauteur();
        bords();
        if (window.innerWidth === larg) return;
        larg = window.innerWidth;
        var bo = $('.fx-n[aria-expanded="true"]', fr);
        railVers(bo ? +bo.getAttribute('data-n') : 0, false);
      }, 90);
    });
    if (doc.fonts && doc.fonts.ready) doc.fonts.ready.then(function () { hauteur(); railVers(N, false); bords(); });
  }

  /* « VOUS AIMEREZ AUSSI » (section Horizon chargée après la page) : les produits déjà proposés plus haut (Le matériel et
     l'étape ouverte à l'arrivée, #dcf-fil[data-deja]) en sont RETIRÉS : la diapositive entière reçoit l'attribut hidden, que le
     carrousel d'Horizon ignore déjà (assets/slideshow.js, accesseur slides) et que la grille saute ; s'il reste moins de 2
     cartes, toute la partie est masquée. Rien ne touche aux fichiers des cartes ni aux modèles. */
  /* DC 04/11/2026 (contrôle 2, carte en promotion criarde juste sous « Le fil ») : les recommandations de Shopify ne
     connaissent pas la règle de mise en avant de Le matériel et de la frise (snippets/dc-fiche-rubriques.liquid) ; une carte
     de la marque écartée (marque écrite sur la carte, .dc-cv, ou adresse du produit) est retirée comme les doublons. */
  function vaa() {
    var fil = doc.getElementById('dcf-fil');
    var deja = fil ? (fil.getAttribute('data-deja') || '').split(',').filter(Boolean) : [];
    var reco = $('main product-recommendations');
    if (!reco) return;
    var handle = function (h) { return ((String(h).split('/products/')[1] || '').split(/[?#/]/)[0]) || ''; };
    var ecartee = function (s, h) {
      var mq = $('.dc-cv', s);
      return /fictech/i.test(h + ' ' + (mq ? mq.textContent : ''));
    };
    var passe = function () {
      var slides = $$('slideshow-slide, .resource-list__item', reco).filter(function (s) { return !s.parentNode.closest('slideshow-slide, .resource-list__item'); });
      if (!slides.length) return;
      var change = false;
      slides.forEach(function (s) {
        var a = $('a[href*="/products/"]', s); if (!a || s.hidden) return;
        var h = handle(a.getAttribute('href'));
        if (deja.indexOf(h) >= 0 || ecartee(s, h)) { s.hidden = true; change = true; }
      });
      var sec = reco.closest('.shopify-section') || reco;
      var reste = slides.filter(function (s) { return !s.hidden; }).length;
      if (reste < 2 && !sec.hidden) sec.hidden = true;
      // DC 04/11/2026 : nombre de cartes restantes, lu par assets/dc-fiche.css (4 cartes = 4 colonnes à l'ordinateur)
      if (reco.getAttribute('data-fx-n') !== String(reste)) reco.setAttribute('data-fx-n', String(reste));
      if (change) window.dispatchEvent(new Event('resize'));
    };
    passe();
    try { new MutationObserver(passe).observe(reco, { childList: true, subtree: true }); } catch (e) {}
  }

  function rubriques() {
    var rub = doc.getElementById('dcf-rub');
    var acc = accroche();
    apercus(acc);
    if (rub) {
      // dose unique déjà donnée par une étape : pas de répétition
      $$('.dcf-dosebloc[data-fixe-q]', rub).forEach(function (bl) {
        var q = bl.getAttribute('data-fixe-q');
        var tx = $$('.fx-pas, .fx-pas-seul', rub).map(function (e) { return e.textContent; }).join(' ').replace(/\s+/g, ' ');
        if (q && tx.indexOf(q) >= 0) bl.hidden = true;
      });
      // REPRISE 1 (03/11) : une note de la dose déjà dite par une étape ou une précaution n'est montrée qu'une fois
      notesDejaDites(rub);
    }
    // typographie française sur le texte des fiches : apostrophe courbe, espace fine insécable avant : ; ? ! et dans « »
    var RX = [[/(\p{L})'(\p{L})/gu, '$1’$2'], [/[  ]([:;?!])(?=\s|$)/g, ' $1'], [/«[  ]?/g, '« '], [/[  ]?»/g, ' »'], [/(\d) (€|L\b|ml\b|kg\b|h\b|%)/g, '$1 $2']];
    [rub, doc.getElementById('dcf-bande')].forEach(function (zone) {
      if (!zone) return;
      var w = doc.createTreeWalker(zone, NodeFilter.SHOW_TEXT), n;
      while ((n = w.nextNode())) {
        if (n.parentNode && n.parentNode.tagName === 'SCRIPT') continue;
        var vv = RX.reduce(function (a, r) { return a.replace(r[0], r[1]); }, n.nodeValue);
        if (vv !== n.nodeValue) n.nodeValue = vv;
      }
    });
    frise();
    vaa();
  }

  // ---------- démarrage ----------
  function demarrer() {
    // DC 04/11/2026 (contrôle 2) : posé AVANT le 1er rendu, pour que l'encadré de stock (sections/dc-product-head.liquid,
    // committedId) lise le format de la fiche dès son 1er passage
    window.__dcf = { S: S, rendre: rendre, poser: poser, choisir: choisir, PORT: PORT, geometrie: geometrie, geo: function () { return GEO; } };
    rendre();
    rubriques();
    var v = parId[S.sel];
    if (PHOTOS.length) {
      var k = v && v.m ? PHOTOS.map(function (p) { return p.id; }).indexOf(v.m) : -1;
      S.photo = k >= 0 ? k : 0;
      var dots = $$('.dcf-dots button', root);
      dots.forEach(function (b, i) { b.setAttribute('aria-pressed', i === S.photo ? 'true' : 'false'); });
    }
    geometrie();
    poser();
    analyser();
    if (E.img && !E.img.complete) E.img.addEventListener('load', poser, { once: true });
    surDefilement();
    if (doc.fonts && doc.fonts.ready) doc.fonts.ready.then(prixLignes);
    /* le moteur suit le format montré (ex. France : un format en retrait n'est jamais proposé). DC 04/11/2026 (contrôle 2, vente
       bloquée : voir moteurChoisir) : seulement une fois le sélecteur et le formulaire d'Horizon DÉFINIS (modules chargés après
       ce script ; 5 s au plus), puis un contrôle 2,5 s plus tard qui relance la mise à jour d'Horizon si le moteur n'a toujours
       pas suivi (rien n'est relancé pendant un ajout en cours) */
    var ce = window.customElements;
    var definis = (ce && ce.whenDefined) ? Promise.race([
      Promise.all([ce.whenDefined('variant-picker'), ce.whenDefined('product-form-component')]),
      new Promise(function (ok) { setTimeout(ok, 5000); })
    ]) : Promise.resolve();
    var suivre = function (forcer) { if (!S.attente && moteurId() && moteurId() !== S.sel && parId[S.sel]) moteurChoisir(parId[S.sel], forcer); };
    definis.then(function () { setTimeout(function () { suivre(false); }, 0); setTimeout(function () { suivre(true); }, 2500); });
    /* DC 04/11/2026 (avant publication) : 6,5 s après le chargement, un format commandable que le moteur ne porte toujours pas =
       « Ajouter » et la barre grisés avec le message (poserKo) ; un format épuisé ou non vendu dans le pays n'est pas concerné */
    setTimeout(function () {
      var v0 = parId[S.sel];
      if (!S.attente && moteurId() && moteurId() !== S.sel && v0 && proposable(v0) && etat(v0).st !== 'out' && plafond(v0) >= 1) poserKo();
    }, 6500);
  }
  if (doc.readyState === 'loading') doc.addEventListener('DOMContentLoaded', demarrer); else demarrer();
})();
